import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { get } from 'lodash'
import { push } from 'connected-react-router'
import { notification, modal } from 'redux/modules/app'
import { activity as activityApi } from 'redux/modules/api/combineDashboard'
import { fetchAward } from 'redux/modules/api/dashboard/awards'
import { schemaActivitySetup, schemaActivityEdit } from 'models/activities'
import { schemaAlreadyAssessed, schemaApproval } from 'models/approvals'
import { putBlob } from 'redux/modules/api/blob'

function decorator(config = { loaders: [] }) {
  return ComposedComponent => {
    @connect(
      ({ api }) => {
        const loaders = {}

        config.loaders.forEach(key => {
          loaders[`${key}Status`] = get(api, `dashboard.activity['${key}']`)
        })

        return {
          ...loaders,
          activityLogs: get(api, 'dashboard.activity.logs'),
          activityOverview: get(api, 'dashboard.activity.overview'),
          activityCategories: get(api, 'dashboard.activity.categories')
        }
      },
      {
        ...activityApi,
        notification,
        fetchAward,
        modal,
        push,
        putBlob
      }
    )
    class apiActivity extends Component {
      static propTypes = {
        getActivitiesAssessment: PropTypes.func,
        awardId: PropTypes.number,
        createActivity: PropTypes.func,
        sendAssessmentRequest: PropTypes.func.isRequired,
        getActivitiesApproval: PropTypes.func,
        getActivityCategories: PropTypes.func.isRequired,
        uploadActivityReport: PropTypes.func.isRequired,
        putBlob: PropTypes.func.isRequired,
        getActivitiesSignOff: PropTypes.func,
        sendLeaderRequest: PropTypes.func.isRequired,
        uploadPaperAssessorReport: PropTypes.func.isRequired,
        setupActivity: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        editActivity: PropTypes.func.isRequired,
        getOverview: PropTypes.func.isRequired,
        fetchAward: PropTypes.func.isRequired,
        getLogs: PropTypes.func.isRequired,
        modal: PropTypes.func.isRequired,
        resendAssessmentRequest: PropTypes.func,
        activityAssessorRejection: PropTypes.func
      }

      static defaultProps = {
        params: {}
      }

      handleGetLogs = id => this.props.getLogs(id)

      handleGetActivitiesAssessment = (awardId, actionId) =>
        this.props.getActivitiesAssessment(awardId, actionId)

      handleGetActivitiesSignOff = (awardId, actionId) =>
        this.props.getActivitiesSignOff(awardId, actionId)

      handleGetActivityAssessorUploadReport = (activityId, file) =>
        this.props
          .putBlob({
            blob: file,
            fileName: file.name
          })
          .then(({ body } = {}) =>
            this.props
              .uploadActivityReport(activityId, {
                urlAssessorReportPhotos: [body.url]
              })
              .then(() => {
                this.handleSuccess(
                  'Report has been sent',
                  'notifications.report_has_been_sent'
                )
              })
          )
          .catch(this.handleError)

      handleGetActivitiesApproval = (awardId, actionId) =>
        this.props.getActivitiesApproval(awardId, actionId)

      handleGetActivityCategories = () => this.props.getActivityCategories()

      handleGetOverview = id => this.props.getOverview(id)

      handleSetupActivity = (id, fields, { resetForm, activitySection }) =>
        this.props
          .setupActivity(id, schemaActivitySetup(fields, id, activitySection))
          .then(() => {
            this.handleSuccess(
              'New activity has been added',
              'notifications.new_activity_has_been_added',
              resetForm
            )
          })
          .catch(this.handleError)

      handleCreateActivity = (
        awardId,
        fields,
        { resetForm, activitySection, activityId }
      ) =>
        this.props
          .createActivity(
            this.props.awardId,
            schemaActivitySetup(fields, undefined, activitySection, {
              isAdditional: true
            })
          )
          .then(() =>
            this.handleSuccess(
              'New activity has been added',
              'notifications.new_activity_has_been_added',
              resetForm
            )
          )
          .then(() => this.handleGetOverview(activityId))
          .catch(this.handleError)

      handleEditActivity = (id, fields, { resetForm, activity }) =>
        this.props
          .editActivity(id, schemaActivityEdit(fields, activity))
          .then(() => {
            this.handleGetOverview(id)
            this.handleSuccess(
              'Activity has been edited',
              'notifications.activity_has_been_edited',
              resetForm
            )
          })
          .catch(this.handleError)

      handleSendAssessmentRequest = (id, fields, { resetForm }) => {
        this.props
          .sendAssessmentRequest(id, schemaApproval(fields))
          .then(() =>
            this.handleSuccess(
              'Assessment request has been sent',
              'notifications.assessment_request_sent',
              resetForm
            )
          )
          .catch(this.handleError)
      }

      handleSendAlreadyAssessed = (id, fields, { resetForm }) =>
        this.props
          .uploadPaperAssessorReport(id, schemaAlreadyAssessed(fields))
          .then(() =>
            this.handleSuccess(
              'Assessment has been sent',
              'notifications.assessment_sent',
              resetForm
            )
          )
          .catch(this.handleError)

      handleSendLeaderRequest = (id, lastPersonalReflection, fields, { resetForm }) =>
        this.props
          .sendLeaderRequest(id, schemaApproval(fields, lastPersonalReflection))
          .then(() =>
            this.handleSuccess(
              'Leader approval request has been sent',
              'notifications.leader_approval_sent',
              resetForm
            )
          )
          .catch(this.handleError)


      handleSuccess = (
        text = 'Success',
        intlKey = 'notifications.success',
        resetForm
      ) => {
        this.props.notification(text, { status: 'success', intlKey })
        this.props.modal(null, null)
        this.handleRefreshAward()
        resetForm && resetForm()
      }

      handleError = err => {
        console.debug('error', err.body && err.body.userMessage)
        this.props.notification(
          err.body &&
            (err.body.userMessage || err.body.developerMessage || 'Error'),
          'error'
        )
        throw err
      }

      handleRefreshAward = () => {
        const { params, awardId } = this.props
        const id = params.awardId || awardId

        id && this.props.fetchAward(id, { fetchActivity: true })
      }

      handleResendAssessmentRequest = activityId =>
        this.props
          .resendAssessmentRequest(activityId)
          .then(() =>
            this.props.notification('Assessment request has been sent.', {
              status: 'success',
              intlKey: 'notifications.assessment_request_sent'
            })
          )
          .catch(this.handleError)

      handleActivityAssessorRejection = (activityId, fields) =>
        this.props
          .activityAssessorRejection(activityId, fields)
          .then(() =>
            this.props.notification('Activity has been rejected', {
              status: 'success',
              intlKey: 'notifications.activity_has_been_rejected'
            })
          )
          .catch(this.handleError)

      render() {
        return (
          <ComposedComponent
            {...this.props}
            onCreateActivity={this.handleCreateActivity}
            onGetActivitiesAssessment={this.handleGetActivitiesAssessment}
            onGetActivityCategories={this.handleGetActivityCategories}
            onGetActivitiesApproval={this.handleGetActivitiesApproval}
            onSendAssessmentRequest={this.handleSendAssessmentRequest}
            onGetActivitiesSignOff={this.handleGetActivitiesSignOff}
            activityUploadReport={this.handleGetActivityAssessorUploadReport}
            onSendAlreadyAssessed={this.handleSendAlreadyAssessed}
            onSendLeaderRequest={this.handleSendLeaderRequest}
            onResendAssessmentRequest={this.handleResendAssessmentRequest}
            onSetupActivity={this.handleSetupActivity}
            onEditActivity={this.handleEditActivity}
            onGetOverview={this.handleGetOverview}
            onGetLogs={this.handleGetLogs}
            activityAssessorRejection={this.handleActivityAssessorRejection}
          />
        )
      }
    }
    return apiActivity
  }
}

export default decorator
